import React from 'react';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import 'classnames';
import '../../../common/GradientWrapper/index.js';
import { Icon } from '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import * as index from '../../../icons/index.js';

const GameIcon = ({ icon }) => {
  if (icon && index[icon]) {
    return /* @__PURE__ */ React.createElement(Icon, { iconName: icon });
  }
  if (/[.,/]/g.test(icon)) {
    return /* @__PURE__ */ React.createElement(Icon, { customIcon: icon });
  }
  return /* @__PURE__ */ React.createElement(Icon, { iconName: "Game" });
};

export { GameIcon };
//# sourceMappingURL=index.js.map
